import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import RegLoginInputs from "../../shared-components/Form/RegLoginInputs";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import lock from "../../assets/images/lock.svg";
import toast from "react-hot-toast";
import DashboardLayout from "../../shared-components/Layout/DashboardLayout";
import { Formik } from "formik";
import * as Yup from "yup";
import { PASSWORD_REGEX, PASSWORD_MESSAGE } from "../../utils/password";
import HervestLoading from "../../shared-components/Layout/HervestLoading";
import userServices from "../../features/user/userAction";

const UpdatePassword = () => {
  useEffect(() => {
    document.title = "HerVest | Profile";
  }, []);

  const [OldPassword, setOldPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [newPassword, setnewPassword] = useState("");
  const [passwordShown, SetpasswordShown] = useState("");
  const [loading, setLoading] = useState(false);

  const changePasswordData = {
    // code,
    password: confirmNewPassword,
  };

  const onChangePassword = async () => {
    try {
      if (newPassword === confirmNewPassword) {
        setLoading(true);

        const PasswordFormData = new FormData();
        PasswordFormData.append("old_password", OldPassword);
        PasswordFormData.append("new_password", newPassword);
        PasswordFormData.append(
          "new_password_confirmation",
          confirmNewPassword
        );

        const res = await userServices.updatePassword(PasswordFormData);
        if (res) {
          toast.success("Password changed successfully");
        }
        setLoading(false);
      } else {
        toast.error("Password does not match");
      }
    } catch (error) {
      setLoading(false);

      toast(error.response.message);
    }
  };

  return (
    <DashboardLayout title="Profile">
      {loading && <HervestLoading />}
      <div>
        <div>
          <p className="md:px-16  text-[18px] font-[700px] leading-5 BoldFonter">
            Manage Account
          </p>

          <div className="flex flex-row space-x-6 md:space-x-12 items-center pb-1 md:pb-3 pt-12 ">
            <Link to="/Profile">
              <p className="text-[16px] font-[400px] leading-5 text-[#666666]">
                Personal Information
              </p>
            </Link>
            <Link to="/NOK">
              <p className="flex text-[16px] font-[400px] leading-5 float-right text-[#666666] ">
                Next of Kin
              </p>
            </Link>
            <Link to="/Bank">
              <p className="text-[14px] font-[400px] leading-5 float-right text-[#666666]">
                Banks
              </p>
            </Link>
            <Link to="/Cards">
              <p className="text-[14px] font-[400px] leading-5 float-right text-[#666666]">
                Cards
              </p>
            </Link>
            <Link to="/ChangePassword">
              <p className="text-[14px] font-[400px] leading-5 float-right text-[#5B2E4F] underline decoration-2 decoration-[#5B2E4F] underline-offset-8 md:underline-offset-[15px]">
                Change Password
              </p>
            </Link>
          </div>
          <hr />

          <Formik
            initialValues={{
              old_password: "",
              new_password: "",
              new_password_confirmation: "",
            }}
            validationSchema={Yup.object({
              old_password: Yup.string().required("Required"),
              new_password: Yup.string()
                .matches(PASSWORD_REGEX, PASSWORD_MESSAGE)
                .required("Required"),
              new_password_confirmation: Yup.string().required("Required"),
            })}
          >
            {({ values, errors, handleChange, handleBlur, handleSubmit }) => (
              <form className="pt-8 md:pt-16 pb-10">
                <div className="md:grid md:grid-cols-3 md:gap-x-20 lg:gap-x-0 w-full">
                  <div className="mb-2 md:mb-0">
                    <label
                      className="block text-[18px] font-[500px] leading-7 MediumFonter"
                      htmlFor="inline-currentpassword"
                    >
                      Current Password
                    </label>
                  </div>
                  <div className="relative w-full md:w-80">
                    <RegLoginInputs
                      icon={lock}
                      type={passwordShown ? "text" : "password"}
                      placeholder="Enter old password"
                      onChange={(e) => setOldPassword(e.target.value)}
                      value={OldPassword}
                    />
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5">
                      {passwordShown ? (
                        <FaEye
                          onClick={() => SetpasswordShown(false)}
                          className="text-right"
                        />
                      ) : (
                        <FaEyeSlash
                          onClick={() => SetpasswordShown(true)}
                          className="text-right"
                        />
                      )}
                    </div>
                  </div>
                  <br />
                </div>

                <div className="md:grid md:grid-cols-3 md:gap-x-20 lg:gap-x-0 w-full md:mt-6">
                  <div className="mb-2 md:mb-0">
                    <label
                      className="block text-[18px] font-[500px] leading-7 MediumFonter"
                      htmlFor="inline-new-password"
                    >
                      Enter new password
                    </label>
                  </div>
                  <div className="relative w-full md:w-80">
                    <RegLoginInputs
                      icon={lock}
                      type={passwordShown ? "text" : "password"}
                      placeholder="Enter new password"
                      onChange={(e) => setnewPassword(e.target.value)}
                      value={newPassword}
                    />
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5">
                      {passwordShown ? (
                        <FaEye
                          onClick={() => SetpasswordShown(false)}
                          className="text-right"
                        />
                      ) : (
                        <FaEyeSlash
                          onClick={() => SetpasswordShown(true)}
                          className="text-right"
                        />
                      )}
                    </div>
                  </div>
                  <br />
                </div>

                <div className="md:grid md:grid-cols-3 md:gap-x-20 lg:gap-x-0 w-full md:mt-6">
                  <div className="mb-2 md:mb-0">
                    <label
                      className="block text-[18px] font-[500px] leading-7 MediumFonter"
                      htmlFor="inline-Confirm-new-password"
                    >
                      Confirm new password
                    </label>
                  </div>
                  <div className="relative w-full md:w-80">
                    <RegLoginInputs
                      icon={lock}
                      type={passwordShown ? "text" : "password"}
                      placeholder="Confirm new password"
                      onChange={(e) => setConfirmNewPassword(e.target.value)}
                      value={confirmNewPassword}
                    />
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5">
                      {passwordShown ? (
                        <FaEye
                          onClick={() => SetpasswordShown(false)}
                          className="text-right"
                        />
                      ) : (
                        <FaEyeSlash
                          onClick={() => SetpasswordShown(true)}
                          className="text-right"
                        />
                      )}
                    </div>
                  </div>
                  <br />
                </div>

                <div className="md:grid md:grid-cols-3 md:gap-x-20 lg:gap-x-0 w-full md:mt-6">
                  <div className="mb-2 md:mb-0">
                    <label
                      className="block text-[18px] font-[500px] leading-7 MediumFonter"
                      htmlFor=""
                    ></label>
                  </div>
                  <div className="w-full">
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        onChangePassword();
                      }}
                      className="w-full md:w-80 bg-[#5B2E4F] rounded text-white px-10 py-2 text-[12px] font-[500px] leading-4 my-5"
                    >
                      CHANGE PASSWORD
                    </button>
                  </div>
                  <br />
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default UpdatePassword;
